;(function() {
  'use strict';
  /* global angular */

  var DEFAULT_MICROSITE_SORT = 'price--asc';

  angular
    .module("Milestone.microsite")


    // this has to be a sub-controfller of FloorPlansTabsCtrl
    .controller("FloorPlansCtrl", ['$scope', '$rootScope', '$http', '$timeout', '$window', '$document', 'device', '$modal', function($scope, $rootScope, $http, $timeout, $window, $document, device, $modal) {

      $scope.naturalSort = function(community) {
        return community.name.replace(/^The /, '');
      };















      var lastFilterParams = '';
      var localStore = {};
      var initializing = true;
      var residencesRequestId = 0;

      $scope.urlSearchParams = new URLSearchParams($window.location.search);
      $scope.ddMenu1 = false;
      $scope.ddMenu2 = false;
      $scope.ddMenu3 = false;
      $scope.isFiltersApplied = false;
      $scope.isLoading = true;

      $scope.residenceFilters = {
        regionId: '',
        communityId: '',
        residenceSeriesId: '',
        price: '',
        beds: '',
        baths: '',
        sqft: '',
        availability: '',
        sortBy: DEFAULT_MICROSITE_SORT,
        page: 1,
      };
      $scope.previouslySelectedRegionId = $scope.residenceFilters.regionId;
      $scope.previouslySelectedCommunityId = $scope.residenceFilters.communityId;
      $scope.previouslySelectedResidenceSeriesId = $scope.residenceFilters.residenceSeriesId;
      $scope.regionOptions = regionOptions || [];
      $scope.communityOptions = communityOptions || [];
      $scope.filteredCommunityOptions = [];
      $scope.filteredCommunityOptions = getFilteredCommunityOptions();

      $scope.pagination = {
        lastPage: 1,
        currentPage: 1,
        pages: [],
      };

      $scope.$watch('ddMenu1', function(is, was) {
        var numDropdownsOpen = 0;

        if ($scope.ddMenu1) {
          numDropdownsOpen++;
        }
        if ($scope.ddMenu2) {
          numDropdownsOpen++;
        }
        if ($scope.ddMenu3) {
          numDropdownsOpen++;
        }

        $timeout(function() {
          if (is) {
            $scope.ddMenu2 = false;
            $scope.ddMenu3 = false;
          }

          if (numDropdownsOpen > 0) {
            $document[0].addEventListener('keydown', $scope.closeFilterDropdowns, false);
          }
        });


      });

      $scope.$watch('ddMenu2', function(is, was) {
        var numDropdownsOpen = 0;

        if ($scope.ddMenu1) {
          numDropdownsOpen++;
        }
        if ($scope.ddMenu2) {
          numDropdownsOpen++;
        }
        if ($scope.ddMenu3) {
          numDropdownsOpen++;
        }

        $timeout(function() {
          if (is) {
            $scope.ddMenu1 = false;
            $scope.ddMenu3 = false;
          }

          if (numDropdownsOpen > 0) {
            $document[0].addEventListener('keydown', $scope.closeFilterDropdowns, false);
          }
        });
      });

      $scope.$watch('ddMenu3', function(is, was) {
        var numDropdownsOpen = 0;

        if ($scope.ddMenu1) {
          numDropdownsOpen++;
        }
        if ($scope.ddMenu2) {
          numDropdownsOpen++;
        }
        if ($scope.ddMenu3) {
          numDropdownsOpen++;
        }

        $timeout(function() {
          if (is) {
            $scope.ddMenu1 = false;
            $scope.ddMenu2 = false;
          }

          if (numDropdownsOpen > 0) {
            $document[0].addEventListener('keydown', $scope.closeFilterDropdowns, false);
          }
        });


      });

      $scope.$watch('residenceFilters', function(is, was) {
        if (initializing) {
          return;
        }

        $timeout(function() {
          applyFilterDependencies();
          getFilteredResidences();
        });
      }, true);

      $scope.open = function (residence) {
        if (residence.activate_details_page) {
          $window.open(residence.url, '_blank');
          return;
        }

        $scope.residence = residence;

        var modalInstance = $modal.open({
          templateUrl: 'availableResidenceModalContent.html',
          controller: 'AvailableResidenceModalInstanceCtrl',
          windowClass: 'modal-available-residence',
          animation: true,
          scope: $scope
        });
      };

      $scope.viewFloorPlansAndElevations = function (residence) {
        $scope.residence = residence;

        var modalInstance = $modal.open({
          templateUrl: 'availableResidenceModalContent.html',
          controller: 'AvailableResidenceModalInstanceCtrl',
          windowClass: 'modal-available-residence',
          animation: true,
          scope: $scope
        });
      };

      $scope.gallery = function(residence) {
        $scope.residence = residence;
        $scope.home = {
          assets: residence.assets || [],
          full_address: residence.name,
          name: residence.name
        };

        var modalInstance = $modal.open({
          animation: true,
          templateUrl: 'myModalContent.html',
          controller: 'ModalInstanceCtrl',
          windowClass: 'custom-carousel-modal',
          size: 'lg',
          scope: $scope
        });
      };

      $scope.clearFilters = function() {
        $timeout(function() {
          Object.assign($scope.residenceFilters, {
            // regionId: '',
            // communityId: '',
            price: '',
            beds: '',
            baths: '',
            sqft: '',
            availability: '',
            sortBy: DEFAULT_MICROSITE_SORT,
          });
        });
      };

      $scope.onPageClick = function(page) {
        $scope.pagination.currentPage = page;
        $scope.residenceFilters.page = page;
      };

      $scope.onNextClick = function() {
        if ($scope.pagination.currentPage === $scope.pagination.lastPage) {
          return;
        }

        $scope.onPageClick($scope.pagination.currentPage + 1);
      };

      $scope.onPrevClick = function() {
        if ($scope.pagination.currentPage === 1) {
          return;
        }

        $scope.onPageClick($scope.pagination.currentPage - 1);
      };

      $scope.closeFilterDropdowns = function(event) {
        if (!event || event.key === 'Escape') {
          if ($scope.ddMenu1) {
            $document.find('#ddMenu1').focus();
          }
          if ($scope.ddMenu2) {
            $document.find('#ddMenu2').focus();
          }
          if ($scope.ddMenu3) {
            $document.find('#ddMenu3').focus();
          }

          $timeout(function() {
            $scope.ddMenu1 = false;
            $scope.ddMenu2 = false;
            $scope.ddMenu3 = false;
            $document[0].removeEventListener('keydown', $scope.closeFilterDropdowns);
          });
        }
      }

      function getFilteredCommunityOptions() {
        var filteredCommunityOptions = $scope.residenceFilters.regionId
          ? $scope.communityOptions.filter(function(community) {
            return community.region_id == $scope.residenceFilters.regionId;
          })
          : $scope.communityOptions.filter(function(community) {
            return community;
          });

        return filteredCommunityOptions;
      }

      function applyFilterDependencies() {
        var selectedCommunityOption = $scope.communityOptions.find(function(community) {
          return community.id == $scope.residenceFilters.communityId;
        });
        var selectedRegionOption = $scope.regionOptions.find(function(region) {
          return region.id == $scope.residenceFilters.regionId;
        });
        var communityBelongsToRegion = selectedRegionOption && selectedCommunityOption && selectedRegionOption.id == selectedCommunityOption.region_id;

        $scope.filteredCommunityOptions = getFilteredCommunityOptions();

        if ($scope.residenceFilters.regionId && $scope.residenceFilters.communityId && !communityBelongsToRegion) {
          Object.assign($scope.residenceFilters, {
            communityId: '',
          });
        }

        if (!$scope.residenceFilters.regionId && $scope.previouslySelectedRegionId) {
          Object.assign($scope.residenceFilters, {
            communityId: '',
          });
        }

        if ($scope.residenceFilters.communityId && !$scope.residenceFilters.regionId && !$scope.previouslySelectedCommunityId) {
          Object.assign($scope.residenceFilters, {
            regionId: selectedCommunityOption.region_id + '',
          });
        }

        $scope.previouslySelectedRegionId = $scope.residenceFilters.regionId;
        $scope.previouslySelectedCommunityId = $scope.residenceFilters.communityId;
      }

      function setFiltersFromUrlParams() {
        var params = $scope.residenceFilters;

        if ($scope.community.region_id) {
          params.regionId = $scope.community.region_id;
        }

        if ($scope.community.id) {
          params.communityId = $scope.community.id;
        }

        if ($rootScope.residenceSeriesId) {
          params.residenceSeriesId = $rootScope.residenceSeriesId;
        }
      }

      $scope.$on('residenceSeriesToggleTab', function(event, object) {
        $scope.residenceFilters.residenceSeriesId = object.residenceSeriesId;
      });

      function updateUrlParams() {
        var params = $scope.residenceFilters;
        Object.keys(params).forEach(function(key) {
          if (!params[key] || params[key] === null || params[key] === undefined || params[key] === '') {
            $scope.urlSearchParams.delete(key);
            return;
          }

          if (key === 'page' && params[key] == 1) {
            $scope.urlSearchParams.delete(key);
            return;
          }

          $scope.urlSearchParams.set(key, params[key]);
        });

        $window.history.replaceState({}, '', $window.location.pathname + '?' + $scope.urlSearchParams.toString());
      }

      function getFilterHash(filters) {
        var sortedKeys = Object.keys(filters).sort();
        var paramString = sortedKeys.map(function (key) {
          return key + '=' + filters[key];
        }).join('&');
        var hash = btoa(paramString);

        return hash;
      }

      function getFilteredResidences(page) {
        $scope.residenceFilters.page = page || $scope.pagination.currentPage;


        var params = Object.keys($scope.residenceFilters).reduce(function(acc, key) {
          if ($scope.residenceFilters[key] && $scope.residenceFilters[key] !== null && $scope.residenceFilters[key] !== undefined && $scope.residenceFilters[key] !== '') {
            acc[key] = $scope.residenceFilters[key];
          }

          return acc;
        }, {});
        var stringifiedParams = JSON.stringify(params);

        if (stringifiedParams === lastFilterParams) {
          return;
        }

        lastFilterParams = stringifiedParams;

        var hash = getFilterHash($scope.residenceFilters);

        if (localStore[hash]) {
          $scope.residences = localStore[hash].residences;
          $scope.pagination.currentPage = localStore[hash].currentPage;
          $scope.pagination.lastPage = localStore[hash].lastPage;
          $scope.pagination.pages = localStore[hash].pages;
          $scope.isLoading = false;
          return;
        }

        $scope.isFiltersApplied = false;
        $scope.isLoading = true;

        residencesRequestId++;
        var requestId = residencesRequestId;

        $http.get('/api/residences', {
          params: params,
        }).then(function(response) {
          if (requestId !== residencesRequestId) {
            return;
          }

          var pages = Array.from({ length: response.data.last_page }, function(_, i) { return i + 1; });
          pages.shift();
          pages.pop();
          $scope.residences = response.data.data;
          $scope.pagination.lastPage = response.data.last_page;
          $scope.pagination.currentPage = response.data.current_page;
          $scope.pagination.pages = pages;
          $scope.isFiltersApplied = response.data.isFiltered;
          $scope.isLoading = false;

          localStore[hash] = {
            residences: $scope.residences,
            currentPage: $scope.pagination.currentPage,
            lastPage: $scope.pagination.lastPage,
            pages: $scope.pagination.pages,
          };
        }).catch(function(error) {
          if (requestId !== residencesRequestId) {
            return;
          }

          console.log(error);
          $scope.isLoading = false;
        });
      }

      setFiltersFromUrlParams();
      applyFilterDependencies();
      initializing = false;
      getFilteredResidences();









    }])

    .controller("FloorPlansElevationsCarouselCtrl", ['$scope', function($scope) {

      $scope.activeImage = 0;

      $scope.$on("floorplans:changedhome", function() {
        // This is here because when we switch plans, if we are on img#4
        // and the new plan only has 2 images, we will get a white screen. -wo
        $scope.activeImage = 0;
      });

      $scope.next = function() {
        if ($scope.activeImage === $scope.floorplanElevation.elevations.length - 1) {
          $scope.activeImage = 0;
        } else {
          $scope.activeImage = $scope.activeImage + 1;
        }
      };

      $scope.prev = function() {
        if ($scope.activeImage === 0) {
          $scope.activeImage = $scope.floorplanElevation.elevations.length - 1;
        } else {
          $scope.activeImage = $scope.activeImage - 1;
        }
      };

    }])

    // this has to be a sub-controller of FloorPlansTabsCtrl
    .controller("AvailableHomesCtrl", ['$scope', '$http', '$timeout', '$window', '$document', '$modal', '$q', 'FloorPlanDataService', function($scope, $http, $timeout, $window, $document, $modal, $q, FloorPlanDataService) {

      $scope.data = FloorPlanDataService.data;

      $scope.homesOfTheWeek = $scope.data.homeWeek;



      var lastFilterParams = '';
        var localStore = {};
        var initializing = true;
        var homesRequestId = 0;
        var maxLoadAttempts = 3;
        var filterWatchTimeout = null;
        var mediaCache = {};

        $scope.urlSearchParams = new URLSearchParams($window.location.search);
        $scope.dropdownMenu1 = false;
        $scope.dropdownMenu2 = false;
        $scope.dropdownMenu3 = false;
        $scope.isFiltersApplied = false;
        $scope.isLoading = true;
        $scope.loadError = false;
        $scope.homes = [];
        $scope.isLoadingHomeMedia = false;
        $scope.showInlineScheduleForm = false;
        $scope.hideScheduleForm = false;
        $scope.showScheduleMessage = false;
        $scope.showScheduleLoader = false;
        $scope.triedScheduleSubmit = false;

        // Defined here so QMI modal (child scope) toggles THIS property —
        // MicrositeCtrl.openScheduleTour would only flip the parent shadow.
        $scope.openScheduleTour = function () {
          $scope.showInlineScheduleForm = !$scope.showInlineScheduleForm;

          if ($scope.showInlineScheduleForm) {
            $timeout(function () {
              var el = document.querySelector('.modal-available-home .inline-schedule-tour-row, .inline-schedule-tour--panel');
              if (el && el.scrollIntoView) {
                el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
              }
            }, 50);
          }
        };

        // Local submit handler: AvailableHomesCtrl shadows hideScheduleForm /
        // showScheduleMessage, so MicrositeCtrl's checkScheduleFormValidation
        // would update the parent scope and never hide this modal form.
        $scope.checkScheduleFormValidation = function (form) {
          $scope.triedScheduleSubmit = true;

          if (!form.$valid) {
            return;
          }

          processScheduleATourForm();
        };

        var processScheduleATourForm = function () {
          $scope.hideScheduleForm = true;
          $scope.showScheduleLoader = true;
          $http({
            method: 'POST',
            url: '/form/to-database',
            data: $.param($scope.schedule),
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          }).success(function (data) {
            $scope.showScheduleLoader = false;
            if (data.status === 'success') {
              clicky_custom.visitor = {
                lead_id: data.id,
                email: data.email,
                signup: '1'
              };

              clicky_custom.goal = {
                name: 'Schedule A Tour'
              };

              clicky.goal('2675');
              clicky.log('/schedule-a-tour/thank-you');
              fbq('track', 'Lead');
              _gaq.push(['_trackPageview', '/ajax-goals/schedule-a-tour']);

              if (typeof googleConversionId !== 'undefined' && typeof googleConversionLabel !== 'undefined' && googleConversionId && googleConversionLabel) {
                $window.google_trackConversion({
                  google_conversion_id: googleConversionId,
                  google_conversion_language: 'en',
                  google_conversion_format: '3',
                  google_conversion_color: 'ffffff',
                  google_conversion_label: googleConversionLabel,
                  google_remarketing_only: false
                });
              }

              $scope.scheduleMessage = data.message;
              $scope.showScheduleMessage = true;
            } else {
              $scope.scheduleMessage = data.message;
              $scope.showScheduleMessage = true;
            }
          });
        };

        $scope.homeFilters = {
          regionId: '',
          communityId: '',
          featuredHomeId: '',
          price: '',
          beds: '',
          baths: '',
          sqft: '',
          availability: '',
          sortBy: DEFAULT_MICROSITE_SORT,
          page: 1,
        };
        $scope.previouslySelectedRegionId = $scope.homeFilters.regionId;
        $scope.previouslySelectedCommunityId = $scope.homeFilters.communityId;
        $scope.regionOptions = regionOptions || [];
        $scope.communityOptions = communityOptions || [];
        $scope.filteredCommunityOptions = [];
        $scope.filteredCommunityOptions = getFilteredCommunityOptions();

        $scope.pagination = {
          lastPage: 1,
          currentPage: 1,
          pages: [],
        };

        $scope.$watch('dropdownMenu1', function(is, was) {
          var numDropdownsOpen = 0;

          if ($scope.dropdownMenu1) {
            numDropdownsOpen++;
          }
          if ($scope.dropdownMenu2) {
            numDropdownsOpen++;
          }
          if ($scope.dropdownMenu3) {
            numDropdownsOpen++;
          }

          $timeout(function() {
            if (is) {
              $scope.dropdownMenu2 = false;
              $scope.dropdownMenu3 = false;
            }

            if (numDropdownsOpen > 0) {
              $document[0].addEventListener('keydown', $scope.closeFilterDropdowns, false);
            }
          });


        });

        $scope.$watch('dropdownMenu2', function(is, was) {
          var numDropdownsOpen = 0;

          if ($scope.dropdownMenu1) {
            numDropdownsOpen++;
          }
          if ($scope.dropdownMenu2) {
            numDropdownsOpen++;
          }
          if ($scope.dropdownMenu3) {
            numDropdownsOpen++;
          }

          $timeout(function() {
            if (is) {
              $scope.dropdownMenu1 = false;
              $scope.dropdownMenu3 = false;
            }

            if (numDropdownsOpen > 0) {
              $document[0].addEventListener('keydown', $scope.closeFilterDropdowns, false);
            }
          });
        });

        $scope.$watch('dropdownMenu3', function(is, was) {
          var numDropdownsOpen = 0;

          if ($scope.dropdownMenu1) {
            numDropdownsOpen++;
          }
          if ($scope.dropdownMenu2) {
            numDropdownsOpen++;
          }
          if ($scope.dropdownMenu3) {
            numDropdownsOpen++;
          }

          $timeout(function() {
            if (is) {
              $scope.dropdownMenu1 = false;
              $scope.dropdownMenu2 = false;
            }

            if (numDropdownsOpen > 0) {
              $document[0].addEventListener('keydown', $scope.closeFilterDropdowns, false);
            }
          });


        });

        $scope.$watch('homeFilters', function(is, was) {
          // Skip Angular's initial watcher callback and any updates during setup.
          if (initializing || is === was) {
            return;
          }

          if (filterWatchTimeout) {
            $timeout.cancel(filterWatchTimeout);
          }

          filterWatchTimeout = $timeout(function() {
            filterWatchTimeout = null;
            applyFilterDependencies();
            getFilteredHomes();
          }, 150);
        }, true);

        function loadHomeMedia(home) {
          if (!home || !home.id) {
            return $q.reject('Missing home');
          }

          if (home._mediaLoaded) {
            return $q.when(home);
          }

          if (mediaCache[home.id]) {
            Object.assign(home, mediaCache[home.id]);
            home._mediaLoaded = true;
            return $q.when(home);
          }

          $scope.isLoadingHomeMedia = true;

          return $http.get('/api/homes/' + home.id, {
            timeout: 30000,
          }).then(function(response) {
            mediaCache[home.id] = response.data;
            Object.assign(home, response.data);
            home.has_gallery = !!(home.assets && home.assets.length);
            home._mediaLoaded = true;
            $scope.isLoadingHomeMedia = false;
            return home;
          }, function(error) {
            $scope.isLoadingHomeMedia = false;
            return $q.reject(error);
          });
        }

        $scope.open = function (home) {
          if (home.activate_details_page) {
            $window.open(home.url, '_blank');
            return;
          }

          loadHomeMedia(home).then(function(enrichedHome) {
            $scope.home = enrichedHome;
            $scope.residence = enrichedHome.residence;
            $scope.showInlineScheduleForm = false;
            $scope.hideScheduleForm = false;
            $scope.showScheduleMessage = false;
            $scope.showScheduleLoader = false;
            $scope.triedScheduleSubmit = false;
            if ($scope.schedule) {
              $scope.schedule.homes = $scope.schedule.homes || [];
              $scope.schedule.homes[0] = enrichedHome.id;
            }

            $modal.open({
              templateUrl: 'availableHomeModalContent.html',
              controller: 'AvailableHomeModalInstanceCtrl',
              windowClass: 'modal-available-home',
              animation: true,
              scope: $scope
            });
          }).catch(function(error) {
            console.log(error);
          });
        };

        $scope.viewFloorPlansAndElevations = function (home) {
          loadHomeMedia(home).then(function(enrichedHome) {
            $scope.home = enrichedHome;
            $scope.residence = enrichedHome.residence;
            $scope.showInlineScheduleForm = false;
            $scope.hideScheduleForm = false;
            $scope.showScheduleMessage = false;
            $scope.showScheduleLoader = false;
            $scope.triedScheduleSubmit = false;
            if ($scope.schedule) {
              $scope.schedule.homes = $scope.schedule.homes || [];
              $scope.schedule.homes[0] = enrichedHome.id;
            }

            $modal.open({
              templateUrl: 'availableHomeModalContent.html',
              controller: 'AvailableHomeModalInstanceCtrl',
              windowClass: 'modal-available-home',
              animation: true,
              scope: $scope
            });
          }).catch(function(error) {
            console.log(error);
          });
        };

        $scope.gallery = function(home) {
          loadHomeMedia(home).then(function(enrichedHome) {
            $scope.home = enrichedHome;

            $modal.open({
              animation: true,
              templateUrl: 'myModalContent.html',
              controller: 'ModalInstanceCtrl',
              windowClass: 'custom-carousel-modal',
              size: 'lg',
              scope: $scope
            });
          }).catch(function(error) {
            console.log(error);
          });
        };

        $scope.clearFilters = function() {
          $timeout(function() {
            Object.assign($scope.homeFilters, {
              // regionId: '',
              // communityId: '',
              // featuredHomeId: '',
              price: '',
              beds: '',
              baths: '',
              sqft: '',
              availability: '',
              sortBy: DEFAULT_MICROSITE_SORT,
            });
          });
        };

        $scope.retryLoadHomes = function() {
          lastFilterParams = '';
          $scope.loadError = false;
          getFilteredHomes();
        };

        $scope.onPageClick = function(page) {
          $scope.pagination.currentPage = page;
          $scope.homeFilters.page = page;
        };

        $scope.onNextClick = function() {
          if ($scope.pagination.currentPage === $scope.pagination.lastPage) {
            return;
          }

          $scope.onPageClick($scope.pagination.currentPage + 1);
        };

        $scope.onPrevClick = function() {
          if ($scope.pagination.currentPage === 1) {
            return;
          }

          $scope.onPageClick($scope.pagination.currentPage - 1);
        };

        $scope.closeFilterDropdowns = function(event) {
          if (!event || event.key === 'Escape') {
            if ($scope.dropdownMenu1) {
              $document.find('#dropdownMenu1').focus();
            }
            if ($scope.dropdownMenu2) {
              $document.find('#dropdownMenu2').focus();
            }
            if ($scope.dropdownMenu3) {
              $document.find('#dropdownMenu3').focus();
            }

            $timeout(function() {
              $scope.dropdownMenu1 = false;
              $scope.dropdownMenu2 = false;
              $scope.dropdownMenu3 = false;
              $document[0].removeEventListener('keydown', $scope.closeFilterDropdowns);
            });
          }
        }

        function getFilteredCommunityOptions() {
          var filteredCommunityOptions = $scope.homeFilters.regionId
            ? $scope.communityOptions.filter(function(community) {
              return community.region_id == $scope.homeFilters.regionId;
            })
            : $scope.communityOptions.filter(function(community) {
              return community;
            });

          return filteredCommunityOptions;
        }

        function applyFilterDependencies() {
          var selectedCommunityOption = $scope.communityOptions.find(function(community) {
            return community.id == $scope.homeFilters.communityId;
          });
          var selectedRegionOption = $scope.regionOptions.find(function(region) {
            return region.id == $scope.homeFilters.regionId;
          });
          var communityBelongsToRegion = selectedRegionOption && selectedCommunityOption && selectedRegionOption.id == selectedCommunityOption.region_id;

          $scope.filteredCommunityOptions = getFilteredCommunityOptions();

          if ($scope.homeFilters.regionId && $scope.homeFilters.communityId && !communityBelongsToRegion) {
            Object.assign($scope.homeFilters, {
              communityId: '',
            });
          }

          if (!$scope.homeFilters.regionId && $scope.previouslySelectedRegionId) {
            Object.assign($scope.homeFilters, {
              communityId: '',
            });
          }

          if ($scope.homeFilters.communityId && !$scope.homeFilters.regionId && !$scope.previouslySelectedCommunityId) {
            Object.assign($scope.homeFilters, {
              regionId: selectedCommunityOption.region_id + '',
            });
          }

          $scope.previouslySelectedRegionId = $scope.homeFilters.regionId;
          $scope.previouslySelectedCommunityId = $scope.homeFilters.communityId;
        }

        function setFiltersFromUrlParams() {
          var params = $scope.homeFilters;

          if ($scope.community.region_id) {
            params.regionId = $scope.community.region_id;
          }

          if ($scope.community.id) {
            params.communityId = $scope.community.id;
          }

          if ($scope.community.featured_home_id) {
            params.featuredHomeId = $scope.community.featured_home_id;
          }
        }

        function updateUrlParams() {
          var params = $scope.homeFilters;
          Object.keys(params).forEach(function(key) {
            if (!params[key] || params[key] === null || params[key] === undefined || params[key] === '') {
              $scope.urlSearchParams.delete(key);
              return;
            }

            if (key === 'page' && params[key] == 1) {
              $scope.urlSearchParams.delete(key);
              return;
            }

            $scope.urlSearchParams.set(key, params[key]);
          });

          $window.history.replaceState({}, '', $window.location.pathname + '?' + $scope.urlSearchParams.toString());
        }

        function getFilterHash(filters) {
          var sortedKeys = Object.keys(filters).sort();
          var paramString = sortedKeys.map(function (key) {
            return key + '=' + filters[key];
          }).join('&');
          var hash = btoa(paramString);

          return hash;
        }

        function getFilteredHomes(page, attempt) {
          attempt = attempt || 0;
          $scope.homeFilters.page = page || $scope.pagination.currentPage;


          var params = Object.keys($scope.homeFilters).reduce(function(acc, key) {
            if ($scope.homeFilters[key] && $scope.homeFilters[key] !== null && $scope.homeFilters[key] !== undefined && $scope.homeFilters[key] !== '') {
              acc[key] = $scope.homeFilters[key];
            }

            return acc;
          }, {});
          var stringifiedParams = JSON.stringify(params);

          if (attempt === 0 && stringifiedParams === lastFilterParams) {
            return;
          }

          lastFilterParams = stringifiedParams;

          var hash = getFilterHash($scope.homeFilters);

          if (localStore[hash]) {
            $scope.homes = localStore[hash].homes;
            $scope.pagination.currentPage = localStore[hash].currentPage;
            $scope.pagination.lastPage = localStore[hash].lastPage;
            $scope.pagination.pages = localStore[hash].pages;
            $scope.isLoading = false;
            $scope.loadError = false;
            return;
          }

          $scope.isFiltersApplied = false;
          $scope.isLoading = true;
          $scope.loadError = false;

          homesRequestId++;
          var requestId = homesRequestId;

          $http.get('/api/homes', {
            params: params,
            timeout: 30000,
          }).then(function(response) {
            if (requestId !== homesRequestId) {
              return;
            }

            var pages = Array.from({ length: response.data.last_page }, function(_, i) { return i + 1; });
            pages.shift();
            pages.pop();
            $scope.homes = response.data.data;
            $scope.pagination.lastPage = response.data.last_page;
            $scope.pagination.currentPage = response.data.current_page;
            $scope.pagination.pages = pages;
            $scope.isFiltersApplied = response.data.isFiltered;
            $scope.isLoading = false;
            $scope.loadError = false;

            localStore[hash] = {
              homes: $scope.homes,
              currentPage: $scope.pagination.currentPage,
              lastPage: $scope.pagination.lastPage,
              pages: $scope.pagination.pages,
            };
          }).catch(function(error) {
            if (requestId !== homesRequestId) {
              return;
            }

            console.log(error);

            var status = error && error.status;
            var shouldRetry = !status || status >= 500;

            if (shouldRetry && attempt + 1 < maxLoadAttempts) {
              $timeout(function() {
                if (requestId !== homesRequestId) {
                  return;
                }
                getFilteredHomes(page, attempt + 1);
              }, 1000 * (attempt + 1));
              return;
            }

            $scope.isLoading = false;
            $scope.loadError = true;
          });
        }

        setFiltersFromUrlParams();
        applyFilterDependencies();
        initializing = false;
        getFilteredHomes();
    }])

    .controller('AvailableHomeModalInstanceCtrl', ['$scope', '$modalInstance', function ($scope, $modalInstance) {
      if ($scope.residence === undefined) {
        return null;
      }

      $scope.floorplanElevation = $scope.residence;
      $scope.images = $scope.floorplanElevation.elevations;

      $scope.activeTab = 'floorplans';

      $scope.ok = function () {
        $modalInstance.close();
      };
    }])

    .controller('ModalInstanceCtrl', ["$scope", '$modalInstance',
      function ($scope, $modalInstance) {

        $scope.myInterval = false;
        $scope.noWrapSlides = false;
        $scope.galleryItem = $scope.home || $scope.residence || {};

        $scope.prev = function () {
          $('#carousel-home').carousel('prev');
        };

        $scope.next = function () {
          $('#carousel-home').carousel('next');
        };

        $scope.cancel = function () {
          $modalInstance.dismiss('cancel');
        };

      }
    ])

    .controller("FloorPlansTabsCtrl", ['$scope', '$rootScope', '$location', 'FloorPlanDataService', '$routeParams', '$timeout',
      function($scope, $rootScope, $location, FloorPlanDataService, $routeParams, $timeout) {

        /*
          Tabs for main tabs (floorplans and available homes)
        */
        $scope.tabs = {
          floorplans: $scope.community.homes.length > 0 ? false : true,
          availablehomes: $scope.community.homes.length > 0 ? true : false
        };

        this.subMenuFloorplan = true;

        $scope.data = FloorPlanDataService.data;
        $scope.homeCards = $scope.data.homeCards;

        $scope.toggleTab = function(tabName, tabId){
          $scope.hideFloorplan();
          $location.url('floorplans');

          var elem = $(tabName.currentTarget);
          elem.addClass('active').siblings().removeClass('active');

          $scope.residenceSeriesId = tabId;
          $rootScope.$broadcast('residenceSeriesToggleTab',{
            'residenceSeriesId': tabId
          });
        }

        $scope.showFloorplan = function(seo_name) {

          // set location if we need to, sometimes this can get called directly....
          if ($location.url() !== 'floorplans/' + seo_name) {
            $location.url('floorplans/' + seo_name);
          }

          $scope.tabs.floorplans = true;
          $scope.tabs.availablehomes = false;

          if ($scope.homeCards === undefined) {
            return null;
          }

          var match = $scope.homeCards.filter(function(card){
            if (card.seo_name === seo_name) {
              return card;
            }
          });

          $scope.floorplanElevation = match.pop();
          $scope.images = $scope.floorplanElevation.elevations;
        };

        $scope.hideFloorplan = function(){
          $scope.floorplanElevation = false;
          $scope.images = [];
        };

        $scope.routeParams = $routeParams;

        $scope.$on("$locationChangeSuccess", function(event, now, was) {
          $timeout(function(){
            if ($scope.routeParams.page === 'floorplans') {
              $scope.tabs.floorplans = true;
              $scope.tabs.availablehomes = false;
            }
            else if ($scope.routeParams.page === 'available-homes') {
              $scope.tabs.floorplans = false;
              $scope.tabs.availablehomes = true;
            }

            if ($scope.routeParams.floorplan) {
              $scope.showFloorplan($scope.routeParams.floorplan);
            }
            else {
              $scope.hideFloorplan();
            }
          });
        });
      }
    ])
  ;

})();
